var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupsIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.5H22V18.5C22 16.8431 20.6569 15.5 19 15.5C18.0444 15.5 17.1931 15.9468 16.6438 16.6429M17 20.5H7M17 20.5V18.5C17 17.8438 16.8736 17.217 16.6438 16.6429M7 20.5H2V18.5C2 16.8431 3.34315 15.5 5 15.5C5.95561 15.5 6.80686 15.9468 7.35625 16.6429M7 20.5V18.5C7 17.8438 7.12642 17.217 7.35625 16.6429M7.35625 16.6429C8.0935 14.801 9.89482 13.5 12 13.5C14.1052 13.5 15.9065 14.801 16.6438 16.6429M15 7.5C15 9.15685 13.6569 10.5 12 10.5C10.3431 10.5 9 9.15685 9 7.5C9 5.84315 10.3431 4.5 12 4.5C13.6569 4.5 15 5.84315 15 7.5ZM21 10.5C21 11.6046 20.1046 12.5 19 12.5C17.8954 12.5 17 11.6046 17 10.5C17 9.39543 17.8954 8.5 19 8.5C20.1046 8.5 21 9.39543 21 10.5ZM7 10.5C7 11.6046 6.10457 12.5 5 12.5C3.89543 12.5 3 11.6046 3 10.5C3 9.39543 3.89543 8.5 5 8.5C6.10457 8.5 7 9.39543 7 10.5Z",
    stroke: "#818586",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsIcons);
export default __webpack_public_path__ + "static/media/GroupsIcons.477790ede9a8e38ad5df3c032c7f78f0.svg";
export { ForwardRef as ReactComponent };